import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {environment} from '../environments/environment';
import {ApiAnalyticsService} from './services/api-analytics.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'apertura';
  constructor(private router:Router,
              private apiAnalyticsService:ApiAnalyticsService) {
    if (environment.production) {
      //window.console.log = () => { }    
    }

    router.events.subscribe((event) => { 
      if (event instanceof NavigationEnd) {
        let url='';
        if(event.url==='/'){
          url='/registro'
        } else {
          url=event.url
        }
        this.apiAnalyticsService.gTagPage(url);
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) { 
    if (environment.production) {
      sessionStorage.clear();
      sessionStorage.setItem('step', 'registro');  
    }    
  }

}
